import styled from "styled-components";

const dividerHeight = 14;

export const Dot = styled.div.attrs(
    (props: { dotRadius: number; isLastElement: boolean; isTurboPaymentMethod: boolean }) => props,
)`
    width: ${(props) => `${props.dotRadius}px`};
    height: ${(props) => `${props.dotRadius}px`};
    margin-right: ${(props) => (props.isLastElement ? `${2 * props.dotRadius}px` : `${props.dotRadius}px`)};
    background-color: ${(props) =>
        props.isTurboPaymentMethod
            ? props.theme.colors[props.theme.colorMode].text_Med_Emphasis
            : props.theme.colors[props.theme.colorMode].text_High_Emphasis};
    border-radius: 100%;
`;

export const CardNumberSubNameContainer = styled.div.attrs(
    (props: { showDivider: boolean; isTurboPaymentMethod: boolean; isTurboV2?: boolean }) => props,
)`
    display: flex;
    align-items: center;

    ${({ isTurboV2 }) =>
        isTurboV2 &&
        `
        flex-shrink: 0;
    `}

    &::before {
        content: "";
        border: ${(props) =>
            props.showDivider ? `1px solid ${props.theme.colors[props.theme.colorMode].divider}` : "none"};
        border-right: ${(props) => (props.isTurboPaymentMethod ? undefined : 0)};
        height: ${dividerHeight}px;
        margin-right: ${(props) => (props.isTurboV2 ? props.theme.spacing.xxSmall : props.theme.spacing.xSmall)};
        margin-left: ${(props) => (props.isTurboV2 ? props.theme.spacing.xxSmall : "6px")};
        border-radius: 10px;
    }
`;
